export const generatePartnerQueryUrl = (
  baseUrl: string,
  parameters: Record<string, string | boolean | number | undefined>,
): string => {
  const [urlPath, existingQuery] = baseUrl.split('?');
  const queryParameters = new URLSearchParams(existingQuery || '');

  for (const [key, value] of Object.entries(parameters)) {
    queryParameters.set(key, String(value));
  }

  const queryString = queryParameters.toString();
  return queryString ? `${urlPath}?${queryString}` : urlPath;
};
